import { Check } from "lucide-react";
import { CtaWhatsApp } from "./Cta";
import { Reveal } from "./motion";

export default function OfferCard({ offer, delay = 0 }) {
  const dark = offer.highlight;
  return (
    <Reveal delay={delay} className="h-full">
      <article
        className={`relative flex h-full flex-col rounded-3xl p-7 transition-transform duration-500 hover:-translate-y-1.5 sm:p-8 ${
          dark
            ? "grain overflow-hidden bg-nuit-900 text-white shadow-[0_30px_60px_-24px_rgba(7,26,45,0.5)]"
            : "border border-nuit-900/10 bg-white text-nuit-900 shadow-[0_16px_40px_-24px_rgba(7,26,45,0.25)]"
        }`}
        data-testid={`offer-${offer.id}`}
      >
        {dark && (
          <span className="absolute right-5 top-5 rounded-full bg-electric px-3 py-1 font-display text-[11px] font-semibold uppercase tracking-wider text-white">
            Le plus choisi
          </span>
        )}
        <h3 className="font-display text-xl font-bold">{offer.name}</h3>
        <p className={`mt-1 text-sm ${dark ? "text-white/60" : "text-steel"}`}>{offer.tagline}</p>
        <p className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-5xl">
          {offer.price}
        </p>
        <ul className="mt-6 flex-1 space-y-3">
          {offer.features.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm leading-relaxed">
              <Check className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-electric-300" : "text-electric"}`} />
              <span className={dark ? "text-white/80" : "text-encre/85"}>{f}</span>
            </li>
          ))}
        </ul>
        <CtaWhatsApp
          label="Commander sur WhatsApp"
          message={offer.message}
          variant={dark ? "primary" : "dark"}
          className="mt-7 w-full [&>a]:w-full"
          testid={`offer-${offer.id}-cta`}
        />
      </article>
    </Reveal>
  );
}
